var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('novelty-item',{attrs:{"summary":_vm.summary},scopedSlots:_vm._u([{key:"count",fn:function(ref){
var count = ref.count;
return [_vm._v("\n    "+_vm._s(count)+" 点\n  ")]}}],null,false,3628183136)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }